import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { VoucherService } from '@app/modules/core/services/vouchers/vouchers.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'bkg-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss'],
  encapsulation: ViewEncapsulation.None //para afectar al css de innerHTML
})
export class CouponComponent {
  @Input() name: any;
  @Input() discount: any;
  @Input() expirationDate: any;
  @Input() isEnabled: boolean;
  @Input() code: string;
  @Input() id: number;
  @Input() type: 'generic' | 'wash' | 'carservice' | 'maintenance' | 'itv' | 'refueling' = 'generic';
  @Output() addVoucherCodeReturn = new EventEmitter<string>();

  iconPath = 'assets/images/icons/sonrisa-ok-blue.svg';
  tooltipContent: string;

  constructor(
    private voucherService: VoucherService,
  ) { }

  ngOnInit() {
    this.iconPath = this.getIconPathByType(this.type);
    this.getVoucherTooltipContent(this.id);
  }

  getIconPathByType(type: string): string {
    switch (type) {
      case 'maintenance':
        return 'https://test.aparcandgo.com/fs/assets/cs_icons/solido-reparaciones-azul.svg';
      case 'itv':
        return 'https://test.aparcandgo.com/fs/assets/cs_icons/logo-itv-azul.svg';
      case 'refueling':
        return 'https://test.aparcandgo.com/fs/assets/cs_icons/solido-refill-azul.svg';
      case 'generic':
        return 'assets/images/icons/sonrisa-ok-blue.svg';
      case 'wash':
        return 'https://test.aparcandgo.com/fs/assets/cs_icons/logo-lavados-azul.svg';
      case 'carservice':
        return 'https://test.aparcandgo.com/fs/assets/cs_icons/logo-carservice-azul.svg';
      default:
        return 'assets/images/icons/sonrisa-ok-blue.svg';
    }
  }

  getVoucherTooltipContent(id: any): any {
    this.voucherService.getPromotionVoucherDescription(id).pipe(untilDestroyed(this)).subscribe((res) => {
      this.tooltipContent = res.promotion_description;
    });
  }

  onToggleCoupon(event: Event): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      this.addVoucherCodeReturn.emit(this.code);
    } else {
      this.addVoucherCodeReturn.emit(null);
    }
  }
}
